<div class="global-search" (keydown.escape)="dialogRef.close()">
  <div class="global-search-header">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      #input
      type="text"
      class="global-search-input"
      [(ngModel)]="query"
      (ngModelChange)="onInput()"
      placeholder="Rechercher une page, un actionnaire, un guichet…"
      autocomplete="off"
    />
    <div class="shortcut" title="Raccourci">
      Echap
    </div>
  </div>

  <div class="global-search-body">
    @if (!query.trim()) {
      <div class="global-search-empty">
        <mat-icon>search</mat-icon>
        <p>Tapez pour rechercher dans les pages et les données.</p>
      </div>
    } @else {
      @if (loading) {
        <div class="global-search-loading">
          <mat-spinner diameter="32"></mat-spinner>
          <span>Recherche en cours…</span>
        </div>
      } @else {
        @if (pageResults.length === 0 && dataResults.length === 0) {
          <div class="global-search-empty">
            <mat-icon>search_off</mat-icon>
            <p>Aucun résultat pour « {{ query }} ».</p>
          </div>
        } @else {
          @if (pageResults.length > 0) {
            <div class="global-search-section">
              <div class="global-search-section-title">
                <mat-icon>draft</mat-icon>
                <span>Pages</span>
              </div>
              @for (p of pageResults; track p.path) {
              <button
                type="button"
                class="global-search-item"
                (click)="selectPage(p)"
              >
                <mat-icon>{{ p.icon }}</mat-icon>
                <span class="label">{{ p.title }}</span>
              </button>
              }
            </div>
          }

          @if (dataResults.length > 0) {
            <div class="global-search-section">
              <div class="global-search-section-title">
                <mat-icon>storage</mat-icon>
                <span>Données</span>
              </div>
              @for (r of dataResults; track r.type + r.id) {
              <button
                type="button"
                class="global-search-item"
                (click)="selectData(r)"
              >
                <mat-icon>{{ getDataIcon(r.type) }}</mat-icon>
                <div class="item-text">
                  <span class="label">{{ r.label }}</span>
                  @if (r.sublabel) {
                    <span class="sublabel">{{ r.sublabel }}</span>
                  }
                </div>
              </button>
              }
            </div>
          }
        }
      }
    }
  </div>
</div>
